export default __webpack_public_path__ + "static/media/cassette.b962dd36.svg";